module.exports = __webpack_public_path__ + "./docs/img/vox-api.489677077f5c485f1efae9748480d1be.svg";